import CaptivePortalSplash from './CaptivePortalSplash';

export default CaptivePortalSplash;
